<div class="sidebar"  #sidebar>
    <div class="logo-details">
        <img [src]="logoImageUrl" [class]="logoImageClass" alt="TeamLease Logo">
        <span class="logo_name"></span>
    </div>
    <ul class="nav-links" [ngClass]="{'expanded': sidebarTabMenuToggle}">
        <li *ngFor="let link of navLinks" class="nav-links-item">
            <div *ngIf="Role === 'PERF' && link.id === 4">
        <li class="workspace-nav-item" [class.workspace-nav-item-expanded]="sidebarTabMenuToggleWorkspace">
            <!-- My Workspace Main Tab -->
            <a class="workspace-nav-link" (click)="onSidebarLinkClick('My WorkSpace', '/Workspace')"
                [routerLink]="link.hrefurl" routerLinkActive="active">
                <img src="../../assets/vectors/Workspace_Icon.svg" alt="My Workspace" class="workspace-nav-icon">
                <div class="workspace-link-content">
                    <span class="workspace-link-name">{{ link.name }}</span>
                    <span class="workspace-nav-toggle"
                        [class.workspace-nav-toggle-expanded]="sidebarTabMenuToggleWorkspace"></span>
                </div>
            </a>

            <!-- Workspace Submenu -->
            <div class="workspace-submenu" [class.workspace-submenu-expanded]="sidebarTabMenuToggleWorkspace">
                <div class="workspace-submenu-container" *ngIf="sidebarTabMenuToggleWorkspace">
                    <ul class="workspace-submenu-list">
                        <li *ngFor="let child of link.children" class="workspace-submenu-item">

                            <!-- Returns Activity Block -->
                            <div *ngIf="child.id === 1001" class="returns-activity-wrapper">
                        <li class="returns-activity-item"
                            [class.returns-activity-item-expanded]="sidebarTabMenuToggleReturnsActivity">
                            <a class="returns-activity-link"
                                (click)="sidebarTabMenuToggleReturnsActivity = !sidebarTabMenuToggleReturnsActivity">
                                <img src="../../assets/vectors/Workspace_Icon.svg" alt="Returns Activity"
                                    class="returns-activity-icon">
                                <div class="returns-activity-content">
                                    <span class="returns-activity-name">{{ child.name }}</span>
                                    <span class="returns-activity-toggle"
                                        [class.returns-activity-toggle-expanded]="sidebarTabMenuToggleReturnsActivity"></span>
                                </div>
                            </a>

                            <!-- ER1 Returns Submenu -->
                            <div class="er1-returns-submenu"
                                [class.er1-returns-submenu-expanded]="sidebarTabMenuToggleReturnsActivity">
                                <div class="er1-returns-container" *ngIf="sidebarTabMenuToggleReturnsActivity">
                                    <ul class="er1-returns-list">
                                        <li *ngFor="let subchild of child.children" class="er1-returns-item">
                                            <a class="er1-returns-link"
                                                (click)="onSubSidebarLinkClick(subchild.name, subchild.hrefurl)">
                                                <img [src]="'../../assets/vectors/' + subchild.icon + '.svg'" alt=""
                                                    class="er1-returns-icon">
                                                <span class="er1-returns-name">{{ subchild.name }}</span>
                                            </a>
                                        </li>
                                        <li *ngIf="!child.children?.length" class="er1-returns-empty">
                                            <span class="er1-returns-empty-message">No sub-items</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                </div>
        </li>
    </ul>
</div>
</div>
</li>
</div>

<div *ngIf="Role === 'TLAUD' && link.id === 41">
    <li class="workspace-nav-item" [class.workspace-nav-item-expanded]="sidebarTabMenuToggleAuditScreen">
        <a class="workspace-nav-link" (click)="onSidebarLinkClick('Audit', '')" routerLinkActive="active">
            <img src="../../assets/vectors/Workspace_Icon.svg" alt="My Workspace" class="workspace-nav-icon">
            <div class="workspace-link-content">
                <span class="workspace-link-name">{{ link.name }}</span>
                <span class="workspace-nav-toggle"
                    [class.workspace-nav-toggle-expanded]="sidebarTabMenuToggleAuditScreen"></span>
            </div>
        </a>

        <div class="workspace-submenu" [class.workspace-submenu-expanded]="sidebarTabMenuToggleAuditScreen">
            <div class="workspace-submenu-container" *ngIf="sidebarTabMenuToggleAuditScreen">
                <ul class="workspace-submenu-list">
                    <li *ngFor="let child of link.children" class="workspace-submenu-item">
                        <a class="returns-activity-link" (click)="onSidebarLinkClick(child.name, child.hrefurl)">
                            <img [src]="child.icon ? '../../assets/vectors/' + child.icon + '.svg' : '../../assets/vectors/Workspace_Icon.svg'"
                                alt="{{ child.name }}" class="returns-activity-icon">
                            <div class="returns-activity-content">
                                <span class="returns-activity-name">{{ child.name }}</span>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </li>
</div>

<div *ngIf="(Role === 'HMGR' ||Role=='HAPPR')&& link.id === 36">
    <li class="nav-links-item" [ngClass]="{'expanded': sidebarTabMenuToggleLicences}">
        <a class="nav-links-item-a" (click)="onSidebarTabDownArrayClick(link.id);">
            <img src="../../assets/vectors/Licenses_Icon.svg" alt="" class="nav-link-icons" title="{{link.name}}">
            <div>
                <span class="links-name">Licences</span>
                <span type="button" class="nav-link-toggle-btn" [ngClass]="{'expanded': sidebarTabMenuToggleLicences}">
                </span>
            </div>
        </a>

        <div class="test" [ngClass]="{'expanded': sidebarTabMenuToggleLicences}">
            <div class="nav-sublist-container" *ngIf="sidebarTabMenuToggleLicences" style="height: auto">
                <ul class="nav-sublist">
                    <li *ngFor="let item of licencesDummyData" class="nav-sublist-item">
                        <a class="sublist-item" (click)="onSubSidebarLinkClick(item.name, item.hrefurl);"
                            [ngClass]="{'active': item.name === 'Dashboard'}">
                            <img [src]="'../assets/vectors/' + item.icon + '.svg'" alt=""
                                class="sublist-nav-link-icons">
                            <span>{{ item.name }}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </li>
</div>

<div *ngIf="Role=='HAPPR' && link.id === 7">
    <li class="nav-links-item" [ngClass]="{'expanded': sidebarTabMenuToggleMyDocuments}">
        <a class="nav-links-item-a" (click)="onSidebarTabDownArrayClick(link.id);">
            <img src="../../assets/vectors/My_Documents.svg" alt="" class="nav-link-icons" title="{{link.name}}">
            <div>
                <span class="links-name">My Documents</span>
                <span type="button" class="nav-link-toggle-btn" (click)="onSidebarTabDownArrayClick(link.id);"
                    [ngClass]="{'expanded': sidebarTabMenuToggleMyDocuments}">
                </span>
            </div>
        </a>

        <div class="test" [ngClass]="{'expanded': sidebarTabMenuToggleMyDocuments}">
            <div class="nav-sublist-container" *ngIf="sidebarTabMenuToggleMyDocuments" style="height: auto">
                <ul class="nav-sublist">
                    @if (SpID !== 95) {
                    <li *ngFor="let item of myDocumentSidebarDummyData" class="nav-sublist-item">
                        <a class="sublist-item" (click)="onSubSidebarLinkClick(item.name, item.hrefurl);"
                            [ngClass]="{'active': item.name === 'Dashboard'}">
                            <img [src]="'../assets/vectors/' + item.icon + '.svg'" alt=""
                                class="sublist-nav-link-icons">
                            <span>{{ item.name }}</span>
                        </a>
                    </li>
                    } @else {
                    <li *ngFor="let item of myDocumentSidebarDummyDataSp95" class="nav-sublist-item">
                        <a class="sublist-item" (click)="onSubSidebarLinkClick(item.name, item.hrefurl);"
                            [ngClass]="{'active': item.name === 'Dashboard'}">
                            <img [src]="'../assets/vectors/' + item.icon + '.svg'" alt=""
                                class="sublist-nav-link-icons">
                            <span>{{ item.name }}</span>
                        </a>
                    </li>
                    }
                </ul>
            </div>
        </div>
    </li>
</div>
<div *ngIf="Role === 'HMGR'  && link.id === 8">
    <li class="nav-links-item" [ngClass]="{'expanded': sidebarTabMenuToggleELibrary}">
        <a class="nav-links-item-a" (click)="onSidebarTabDownArrayClick(6);">
            <img src="../../assets/vectors/E_Library_Icon.svg" alt="" class="nav-link-icons" title="{{link.name}}">
            <div>
                <span class="links-name">E Library</span>
                <span type="button" class="nav-link-toggle-btn" (click)="onSidebarTabDownArrayClick(6);"
                    [ngClass]="{'expanded': sidebarTabMenuToggleELibrary}">
                </span>
            </div>
        </a>

        <div class="test" [ngClass]="{'expanded': sidebarTabMenuToggleELibrary}">
            <div class="nav-sublist-container" *ngIf="sidebarTabMenuToggleELibrary" style="height: auto">
                <ul class="nav-sublist">
                    @if (SpID !== 95) {
                    <li *ngFor="let item of ELibrarySidebarDummyData" class="nav-sublist-item">
                        <a class="sublist-item" (click)="onSubSidebarLinkClick(item.name, item.hrefurl);"
                            [ngClass]="{'active': item.name === 'Dashboard'}">
                            <img [src]="'../assets/vectors/' + item.icon + '.svg'" alt=""
                                class="sublist-nav-link-icons">
                            <span>{{ item.name }}</span>
                        </a>
                    </li>
                    } @else {
                    <li *ngFor="let item of ELibrarySidebarDummyData" class="nav-sublist-item">
                        <a class="sublist-item" (click)="onSubSidebarLinkClick(item.name, item.hrefurl);"
                            [ngClass]="{'active': item.name === 'Dashboard'}">
                            <img [src]="'../assets/vectors/' + item.icon + '.svg'" alt=""
                                class="sublist-nav-link-icons">
                            <span>{{ item.name }}</span>
                        </a>
                    </li>
                    }
                </ul>
            </div>
        </div>
    </li>
</div>
<div *ngIf="Role === 'HMGR'  && link.id === 8">
    <li class="nav-links-item" [ngClass]="{'expanded': sidebarTabMenuToggleMyDocuments}">
        <a class="nav-links-item-a" (click)="onSidebarTabDownArrayClick(link.id);">
            <img src="../../assets/vectors/My_Documents.svg" alt="" class="nav-link-icons" title="{{link.name}}">
            <div>
                <span class="links-name">My Documents</span>
                <span type="button" class="nav-link-toggle-btn" (click)="onSidebarTabDownArrayClick(link.id);"
                    [ngClass]="{'expanded': sidebarTabMenuToggleMyDocuments}">
                </span>
            </div>
        </a>

        <div class="test" [ngClass]="{'expanded': sidebarTabMenuToggleMyDocuments}">
            <div class="nav-sublist-container" *ngIf="sidebarTabMenuToggleMyDocuments" style="height: auto">
                <ul class="nav-sublist">
                    @if (SpID !== 95) {
                    <li *ngFor="let item of myDocumentSidebarDummyData" class="nav-sublist-item">
                        <a class="sublist-item" (click)="onSubSidebarLinkClick(item.name, item.hrefurl);"
                            [ngClass]="{'active': item.name === 'Dashboard'}">
                            <img [src]="'../assets/vectors/' + item.icon + '.svg'" alt=""
                                class="sublist-nav-link-icons">
                            <span>{{ item.name }}</span>
                        </a>
                    </li>
                    } @else {
                    <li *ngFor="let item of myDocumentSidebarDummyDataSp95" class="nav-sublist-item">
                        <a class="sublist-item" (click)="onSubSidebarLinkClick(item.name, item.hrefurl);"
                            [ngClass]="{'active': item.name === 'Dashboard'}">
                            <img [src]="'../assets/vectors/' + item.icon + '.svg'" alt=""
                                class="sublist-nav-link-icons">
                            <span>{{ item.name }}</span>
                        </a>
                    </li>
                    }
                </ul>
            </div>
        </div>
    </li>
</div>

<div *ngIf="(link.id !== 12 || (Role !== 'HMGR' && Role !== 'HAPPR')) && 
            (link.id !== 36 || (Role !== 'HMGR' && Role !== 'HAPPR')) && 
            (link.id !== 8 || (Role !== 'HMGR' && Role !== 'HAPPR')) && 
            (link.id !== 6 || (Role !== 'HMGR' && Role !== 'HAPPR')) && 
            (link.id !== 7 || (Role !== 'HMGR'&& Role !== 'HAPPR')) && 
            (link.id !== 16 || (Role !== 'HMGR' && Role !== 'HAPPR')) &&
            (link.id !== 4 || (Role !== 'PERF'))&&
            (link.id !== 41 || (Role !== 'TLAUD'))
            ">
    <a [ngClass]="{'active': link.name === 'Dashboard'}" (click)="onSidebarLinkClick(link.name,link.hrefurl);"
        class="nav-links-item-a">
        <img [src]="'../assets/vectors/'+link.icon+'.svg'" alt="" class="nav-link-icons" title="{{link.name}}">
        <div>
            <span class="links-name">{{ link.name }}</span>
        </div>
    </a>
</div>
</li>
</ul>
</div>
<section class="home-section">
    <nav class="navbar-fluid"
        style="display: flex; justify-content: space-between; align-items: center; position: relative; width: 100%; left: 0;">
        <div class="sidebar-button" style="color: #fff;">
            <i class="menu-btn" (click)="toggleSidebar(!sidebarActive); collapseSidebarSublistsOnSidebarToggle()"><img
                    style="width: 25px;" [src]="toggleimg"></i>
            <span class="dashboard" *ngIf="currentRoute === '/ClientDashboard'" style="font-size: 15px;">
                {{clientName}}
            </span>
            <span class="dashboard"
                *ngIf="currentRoute!=='/EntityDashboard'&&currentRoute!=='/ClientDashboard'&&currentRoute!=='/ER1Returns'"
                style="font-size: 15px;">{{CustomerName}}{{ClientId}}</span>
            <span class="d-flex"
                *ngIf="(currentRoute === '/NoticeDetails' || currentRoute === '/SMEResponse' ||currentRoute === '/SDEXENotice' || currentRoute === '/NoticeDocumentSection')&&(Role === 'SME' || Role === 'SDEXE'||Role=='CORDN')"
                style="font-size: 15px; white-space: nowrap;">
                {{ entityText }}
            </span>

        </div>
        <!-- Black tooltip for the header controls (Switch Entity, profile, Change Password, Logout). -->
        <app-grid-tooltip class="tips-contents" [target]="headerTooltipTarget">
        <div class="navbar-end" style="display: flex; align-items: center;  margin-right: -10px;">
            <i class="bx " title="Switch Entity"
                *ngIf="currentRoute!='/CustomerMasters' && currentRoute!='/EntityMasters' && currentRoute!='/Invoice' && currentRoute!='/Reports'"
                style="color: #fff; font-size: 24px;  margin-right: 5px; "><img style="width: 35px;"
                    (click)="gotoEntityDashboard()" src="../assets/vectors/TransferNav.svg"></i>
            <i class="bx profile-icon toggle-Profile" title="Log Out" style="color: #fff; font-size: 24px;"><img
                    style="width: 35px;" (click)="toggleProfileDropdown()" src="../assets/vectors/Profile.svg"></i>
            <span (click)="toggleProfileDropdown()" class="user-name toggle-Profile"
                style="margin-left: 8px;color: white; font-weight: 500; font-size: 13px; cursor: pointer;"
                [title]="firstName + ' ' + lastName">
                {{ firstName }} {{ lastName }}
            </span>
            <i (click)="toggleProfileDropdown()" class=" fa fa-solid fa-caret-down toggle-Profile"
                aria-hidden="true"></i>
            <div *ngIf="showProfileDropdown" class="profile-dropdown">
                <ul>
                    <li title="Change Password" (click)="changePassword()">
                        <i class="fa fa-lock change-password-icon" style="padding-left: 5px;" aria-hidden="true"></i>
                        Change Password
                    </li>
                    <li title="Logout" (click)="logOut()">
                        <i class="fa fa-power-off change-password-icon" aria-hidden="true"></i>
                        Logout
                    </li>
                </ul>
            </div>
        </div>
        </app-grid-tooltip>
    </nav>
    <br />
    <div class="container-fluid">
        <div class="container-content">

            <div class="container-fluid ">
                <ng-container
                    *ngIf="(currentRoute !== '/EntityDashboard'  && currentRoute !== '/CustomerMasters' && currentRoute !== '/ComplianceDashboard' && currentRoute !== '/UserMaster' && currentRoute !== '/CustomerUserMapping' && currentRoute !== '/ListOfEntities'
                     && currentRoute !== '/Notices'&& currentRoute !== '/DocumentGeneration' && currentRoute !== '/OutputChallanCustomer' && currentRoute !== '/OutputChallanPerformer'
                     && currentRoute !== '/LicenseRequestDetails' && currentRoute !== '/RCPTeam'  && currentRoute !== '/SDExecutor'  && currentRoute !== '/DocumentSection' 
                     && currentRoute !== '/EntityMasters'   
                    && currentRoute !== '/CustomerMaster'&& currentRoute !== '/EntityMaster'
                     && currentRoute !== '/NoticeDetails' && currentRoute !== '/SMEResponse' && currentRoute !== '/SDEXENotice' && currentRoute !== '/NoticeDocumentSection'
                     && currentRoute!=='/ClientEntityDashboard'&& currentRoute!=='/ClientDashboard'&& currentRoute!=='/ClientEntityDashboard' && currentRoute!=='/ClientEntityDashboardGrid' 
                     && currentRoute!=='/EntityAddEdit' && currentRoute !== '/ManageEmployeeAddEdit'&& currentRoute !== '/ExistingRegistrationLicenseInitiateView'&& currentRoute !== '/NewRegistrationLicenseAddNew'
                      && currentRoute!== '/ManageEmployeeBulkUpload'&& currentRoute!== '/AddEditDraftRCPComponent' && currentRoute!=='/ER1AckBulkUpload'&& currentRoute!=='/ER1TotalBranches' && currentRoute!=='/LoginUpload' && currentRoute!=='/LWFViewApplication' 
                      && currentRoute!=='/TlManagementInternalDashboard' &&  currentRoute!=='/InternalDashboardPendingGrid' &&  currentRoute!=='/RCPHeadDashboard' &&  currentRoute!=='/LWFViewApplicablity'  && currentRoute !== '/StateBillingMasterEdit' 
                      && currentRoute !== '/MasterScopingEdit' && currentRoute !== '/CommercialMappingEdit' &&currentRoute !== '/POAddEdit' && currentRoute !='/CustomerAddEdit' && currentRoute != '/CommercialMappingGrid')">
                    <app-tabs></app-tabs>
                    <span
                        *ngIf="!(currentRoute=='/ClientDashboard' || currentRoute=='/PremiseAddEdit' || currentRoute=='/EntityAddEdit'||currentRoute=='/ManageEmployeeAddEdit' ||currentRoute=='/LocationAddEdit' ||currentRoute=='/ContractorAddEdit'||currentRoute=='/CustomerAddEdit' ||currentRoute=='/EntityBulkUpload' ||currentRoute=='/PremiseBulkUpload' ||currentRoute=='/RegistrationRepositoryAddEdit'||currentRoute=='/ListofHolidaysNotifications'||currentRoute=='/Error' )">
                        <hr class="hr-fluid">
                    </span>
                </ng-container>
            </div>
            <!-- Labour's black tooltip for every page's toolbar buttons (Apply, Clear, Add New, Back ...) and breadcrumbs,
                 instead of the browser's native title tooltip. Grid cells keep their own. -->
            <app-grid-tooltip [target]="pageTooltipTarget">
            <router-outlet></router-outlet>
            </app-grid-tooltip>
        </div>
    </div>
</section>

<app-alert-popup *ngIf="alertData.alertVisible" [Width]="250" [Height]="260" [Data]="alertData"
    (close)="closeAlert()"></app-alert-popup>